import { City } from './City';
import { Governorate } from './governorate';
import {UserRole} from './UserRole';

export class User {
    id?: number;
    gender = '';
    firstName = '';
    lastName = '';
    birthDate = '';
    cin = '';
    email = '';
    phone = '';
    gsm = '' ;
    adress = '';
    governorate = '';
    city = '';
    zipCode = '';
    soldeInit = 0;
    cardNumber = '';
    quality = '';
    folderNumber = '';
    userName = '';
    publicId = '';
    password = '';
    solde = 0;
    soldeCompany: any = null;
    status: boolean = null;
    selected = false;
    actif = null;
    dateInscription = '';
    profileImage = '';
    rib = '';
    ribKey = '';
    roles: UserRole[] = [];
    type = '';
    signLink: string = "";
    contribution?: string;
    userArabInfo: UserArabInfo = new UserArabInfo();
    qualityInfo: UserQualityInfo = new UserQualityInfo();
    disciplinaryOrderStatus: string;
    diplome: any;
    affiliationCnss: number = null;
    numeroCnss: string = '';
    /** 1 = première connexion (changement MDP requis), 0 sinon */
    firstLogin: number = 0;
}


export class UserArabInfo{
    firstName   :string;
    lastName    :string;
    quality     :string;
    adress      :string;
    publicId    :string;
}

export class UserQualityInfo{
    dateDefinitive          :string;
    dateMatriculeFiscale    :string;
    dateReclassementDossier :string;
    folderStatus            :string;
    matriculeFiscale        :string;
    publicId                :string;
}